/** Normalize PK mobile for wa.me / sms: links (digits only, 92 prefix). */
export const normalizePkPhone = (contact) => {
  const digits = String(contact || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("92")) return digits;
  if (digits.startsWith("0")) return `92${digits.slice(1)}`;
  return `92${digits}`;
};

export const buildTelUrl = (contact) => {
  const raw = String(contact || "").trim();
  return raw ? `tel:${raw}` : "";
};

export const buildWhatsAppUrl = (contact, message = "") => {
  const phone = normalizePkPhone(contact);
  if (!phone) return "";
  const text = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${phone}${text}`;
};

export const buildSmsUrl = (contact, message = "") => {
  const phone = normalizePkPhone(contact);
  if (!phone) return "";
  const body = message ? `?body=${encodeURIComponent(message)}` : "";
  return `sms:+${phone}${body}`;
};

export const RECEIVABLE_CONTACT_PHONE = "03459518937";
export const RECEIVABLE_CONTACT_NAME = "وجاہت علی";

export const buildReceivableReminderMessage = (customer) => {
  const name = String(customer?.name || "").trim() || "صاحب";
  const due = Number(customer?.recieveable || 0).toLocaleString("en-PK", {
    maximumFractionDigits: 0,
  });

  return `*السلام علیکم*
*محترم ${name}*،
امید ہے آپ خیریت سے ہوں گے۔
یہ پیغام *ارشاد کارٹن ڈیلر* چار باغ سوات کی طرف سے ہے۔
آپ کے نام پر اس وقت
*${due} Rs*
روپے بقایا ہیں۔ ہم آپ سے مودبانہ گزارش کرتے ہیں کہ جلد از جلد ادائیگی فرما دیں تاکہ ہمارا باہمی اعتماد اور تعلق اسی طرح مضبوط رہے۔
کسی بھی معلومات کے لئے براہ کرم اس نمبر پر رابطہ فرمائیں:
📞 *[${RECEIVABLE_CONTACT_PHONE}]${RECEIVABLE_CONTACT_NAME}*

آپ کے تعاون اور اعتماد کے ہم دل سے شکر گزار ہیں۔
اللہ تعالیٰ آپ کے رزق اور کاروبار میں بے پناہ برکت عطا فرمائے۔ آمین
🤲
*حاجی ارشاد سنز*`;
};

export const buildPayableReminderMessage = (company) => {
  const name = company?.name || "Company";
  const due = Number(company?.payable || 0).toLocaleString("en-PK");
  return `Assalam o Alaikum ${name}, hamara baqi payable Rs ${due} hai. Barah-e-karam confirm kar dein. Shukriya — Irshad Carton Dealer`;
};
